module.exports = __webpack_public_path__ + "img/grandsons-min.b4c73dba.jpg";